module.exports = __webpack_public_path__ + "img/Done_rd_blue_70@3x.30ed9d77.png";